import { sectionRenderer } from '@theme/section-renderer';

// Set on the live nodes a render must replace and absent from the server markup, so
// a morph that lands removes it (R-048 rule 1a). renderSection() resolves even when
// nothing landed: a non-2xx body without the section, or a drawer response with no
// matching data-hydration-key (R-048 rules 2 and 5, T30).
const RENDER_PENDING = 'data-tcs-history-render-pending';

/** Renders a section uncached; true only if the marked nodes were replaced. */
async function renderLanded(sectionId, mode, targets) {
  if (!targets.length) return false;
  for (const target of targets) target.setAttribute(RENDER_PENDING, '');
  await sectionRenderer.renderSection(sectionId, { cache: false, mode });
  return targets.every((target) => !target.isConnected || !target.hasAttribute(RENDER_PENDING));
}

// A browser Back can restore the previous page's cart HTML from the back-forward
// cache even though Shopify retained later additions. Read the server cart and
// bypass Horizon's cached section HTML on that restore only.
window.addEventListener('pageshow', async (event) => {
  if (!event.persisted) return;

  try {
    const response = await fetch(`${Theme.routes.cart_url}.js`, { cache: 'no-store' });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    const cart = await response.json();
    if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;

    const renders = [];
    const drawer = document.getElementById('shopify-section-cart-drawer-section');
    if (drawer) {
      renders.push(
        renderLanded('cart-drawer-section', 'hydration', [
          ...drawer.querySelectorAll('[data-hydration-key]'),
        ]),
      );
    }
    const cartPage = document.querySelector('cart-items-component:not([data-drawer])');
    if (cartPage?.dataset.sectionId) {
      renders.push(renderLanded(cartPage.dataset.sectionId, 'full', [cartPage]));
    }

    // A render that resolved without landing would leave the header count beside
    // stale contents, so reload the page instead. The reload is not a persisted
    // pageshow, so it cannot loop.
    if (!(await Promise.all(renders)).every(Boolean)) {
      window.location.reload();
      return;
    }

    for (const icon of document.querySelectorAll('cart-icon')) {
      icon.renderCartBubble?.(cart.item_count, false);
    }
  } catch (error) {
    // A failed cart read or section request (R-048 rule 2): the header is updated only
    // after the renders land, so the restored page stays consistent with itself.
    console.warn('[tcs-cart-history-sync] Could not refresh restored cart:', error);
  }
});
